import { render, staticRenderFns } from "./StorePage.vue?vue&type=template&id=31a288b8&scoped=true&"
import script from "./StorePage.vue?vue&type=script&lang=js&"
export * from "./StorePage.vue?vue&type=script&lang=js&"
import style0 from "./StorePage.vue?vue&type=style&index=0&id=31a288b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a288b8",
  null
  
)

export default component.exports